/**
 * A dialog that stays open beside the Iris panel (CU-869fkdhjv phase 3, UX C3 / C8 / C10): the technique of the
 * Evolution Chart, shared by it and the BI detail dialogs (Season vs last year, My office network).
 *
 * With Iris (`withIris` = the element is askable **and** the user has Iris), the dialog lets the focus go to the
 * panel's box (`disableEnforceFocus`) and leaves the drawer its width (`sx.right`, the `pushRight` of the fixed
 * header). Otherwise the very same props: the focus trap is kept, nothing moves.
 *
 * Pure and alias-free (TL R4).
 */
export function besidePanel(containerProps = {}, { withIris = false, right = 0 } = {}) {
	const props = containerProps || {}
	if (!withIris) return props
	return { ...props, disableEnforceFocus: true, sx: { ...props.sx, right } }
}
